document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 1025) {
    const cartItems = document.querySelectorAll('.cart-item');

    cartItems.forEach(function (cartItem) {
      const details = cartItem.querySelector('.cart-item__details');

      const detailsHeight = details.offsetHeight;

      if (detailsHeight <= 42) {
        cartItem.style.height = '152px';
      } else {
        cartItem.style.height = `${detailsHeight + 110}px`;
      }
    });
  }
});
